import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-scroll";
import Inquire from "./Inquire";
import useIntersect from "./util/useIntersect";
import { motion } from "motion/react";
// import { delay } from "motion";
function Home() {
  const [ref, entry] = useIntersect({
    threshold: 0,
    rootMargin: "-50% 0% -50% 0%",
  });
  useEffect(() => {
    if (entry.isIntersecting) {
      if (entry.isIntersecting) {
        document.querySelectorAll(".nav-link").forEach((i) => {
          i.classList.remove("active");
        });
        document.getElementById("nav-home").classList.add("active");
        // setPosition1("services");
        // document.getElementById("service-title").classList.add("show-line");
      }
    }
    // eslint-disable-next-line
  }, [entry.isIntersecting]);
  const [open, setOpen] = useState(false);
  const type = "inquiry";
  return (
    <Fragment>
      <div className="home gap-5" id="home" ref={ref}>
        <div className="plane-home"></div>
        <motion.div
          initial={{
            opacity: 0,
            scale: 1.05,

            // y: 4,
          }}
          animate={{
            opacity: 1,
            scale: 1,

            // y: 0,
            transition: {
              delay: 3,
              duration: 0.5,
            },
          }}
          className="headline w-full"
        >
          <h1 className="headline-text lg:text-5xl text-3xl leading-relaxed">
            Logistics <span id="headline-underline">Excellence</span>
          </h1>
        </motion.div>
        <motion.div
          className="cta-home"
          initial={{
            opacity: 0,
            scale: 0.95,
            y: -4,
          }}
          animate={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: {
              delay: 3.2,
              duration: 0.5,
              // ease: "circInOut",
            },
          }}
        >
          <Link
            to="service"
            smooth="easeInQuad"
            offset={0}
            duration={500}
            className="cta-one-home"
            id="cta-one-home"
            isDynamic={true}
          >
            Explore Our Expertise
          </Link>
          <button
            className="cta-two-home"
            onClick={() => {
              setOpen(true);
            }}
          >
            Get Solutions Now
          </button>
          {/* <p className="hero-paragraph-mob">
            At Saharawinds Ltd, we empower businesses to expand globally with
            secure, seamless, and cost-effective logistics solutions. From Kenya
            to destinations worldwide, trust our team of logistics experts to
            navigate your unique requirements and ensure timely delivery of
            every consignment.
          </p> */}
        </motion.div>
        <div className="ship-home">
          {/* <p className="hero-paragraph">
            At Saharawinds Ltd, we empower businesses to expand globally with
            secure, seamless, and cost-effective logistics solutions. From Kenya
            to destinations worldwide, trust our team of logistics experts to
            navigate your unique requirements and ensure timely delivery of
            every consignment.
          </p> */}
        </div>
        <Inquire setOpen={setOpen} open={open} type={type} />
      </div>
    </Fragment>
  );
}

export default Home;
